import axios from 'axios'
import qs from 'qs'
import store from '@/store'
import util from './util'
import { ElMessage, ElMessageBox } from 'element-plus'
import CryptoJS from 'crypto-js'
import router from '@/router'

const apiUrl = util.apiUrl()

export function jiami(data, keyOne) {
  let value = getvalsign(data);
  let sha1_result = CryptoJS.HmacSHA1(value, keyOne).toString(CryptoJS.enc.Hex);
  return sha1_result;
}

function getvalsign(data) {
  var key = [];
  for (var o in data) {
    key.push(o);
  }
  key = key.sort();
  var str = "";
  for (var i = 0; i < key.length; i++) {
    var val = data[key[i]];
    if ((typeof val) == "object") {
      val = JSON.stringify(val);
    }
    str += key[i] + "=" + val + "&";
  }
  if (str.length > 0) {
    str = str.substr(0, str.length - 1);
  }
  return str;
}

export function postPlainRequestParams(params) {
  const result = {}
  if (params) {
    for (const key of Object.keys(params)) {
      const value = params[key]
      if (value !== undefined) {
        result[key] = value && typeof value === 'object' ? JSON.stringify(value) : value
      }
    }
  }
  return result
}

const Axios = axios.create({
  baseURL: apiUrl, // 从环境变量获取基础URL
  // timeout: 10000, // 请求超时时间 (暂时先去掉)
})

Axios.interceptors.request.use(config => {
  const route = config.route || router.currentRoute.value
  let user = localStorage.getItem('user');
  let visitorUser = localStorage.getItem('visitorUser')
  let url = apiUrl
  let nowDate = new Date();
  let keyOne;
  let differTime = localStorage.getItem('differTime');
  const temporaryToken = sessionStorage.getItem('temporaryToken') // 扫码填写的临时token
  // 后端说本地测试直接用固定的hashkey，线上的用时间戳
  if (document.domain == "localhost") {
    keyOne = "khosidfopsdfsdowsjdsfsdf";
  }
  else {
    keyOne = Number(nowDate.getTime()) - Number(differTime) + '';
  }
  // console.log("differTime", differTime);
  // console.log("keyOne", keyOne);
  if (user) {
    user = JSON.parse(user)
  }

  if (visitorUser) {
    visitorUser = JSON.parse(visitorUser)
  }
  if (!config.baseURL || config.baseURL === '') {
    config.url = url + config.url;
    config.baseURL = url;
  }
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  let urls = config.url + '?' + qs.stringify(config.data);
  let arr = JSON.parse(JSON.stringify(store.state.postUrl));
  let len = arr.indexOf(urls);
  if (len !== -1) {
    config.cancelToken = source.token;
    source.cancel(urls);
    return config;
  }
  // config 里面的 interceptUrl 为 true 则不拦截请求
  if (config.interceptOff) {
    // 配置 interceptOff 参数为拦截重复提交
    store.commit('upUrl', urls);
  }
  if (config.url === `${config.baseURL}/aiot/getchannellist` || config.url === `${config.baseURL}/aiot/getpreview` || config.url === `${config.baseURL}/aiot/getplayback` || config.url === '/service/api/setServerStamp') {
    config.data = qs.stringify(config.data, { arrayFormat: 'brackets' });
    return config
  }
  if (config.promise) {
    delete config.promise;
    let date = JSON.parse(JSON.stringify(config.data));
    // 判断是否个人空间
    if (
      typeof route.query.upaceid !== 'undefined' || 
      (typeof route.query.upace !== 'undefined' && localStorage.getItem('upaceid'))
    ) {
      date.upaceid = route.query.upaceid || localStorage.getItem('upaceid')
    }
    date.hashkey = keyOne;
    date.hashcode = jiami(date, keyOne);
    config.data = qs.stringify(date, { arrayFormat: 'brackets' });
    return config;
  }
  if (config.method === 'get') {
    // 判断是否个人空间
    if (
      typeof route.query.upaceid !== 'undefined' || 
      (typeof route.query.upace !== 'undefined' && localStorage.getItem('upaceid'))
    ) {
      config.params.upaceid = route.query.upaceid || localStorage.getItem('upaceid')
    }
    config.params.hashkey = keyOne    
    config.params.hashcode = jiami(config.params, keyOne)
    return config
  }
  
  if (config.url === '/api/login' || config.url === `${config.baseURL}/api/getphonemultipleaccounts` || config.url === '/api/getvisitor' || config.url === '/api/lyedulogin' || config.url === '/api/lybinduser' || config.url === '/api/yxptlogin' || config.url === '/api/gzptlogin' || config.url === `${config.baseURL}/api/getsecurityrules` || config.url === '/api/getsecurityrules' || (config.url && (config.url.indexOf('out/') > -1))) { // out/ 不需要登陆的接口    
    if (config.url === `${config.baseURL}/out/getloginweb` || config.url === '/out/getloginweb' || config.url === '/out/registeruser' || config.url === `${config.baseURL}/api/getsecurityrules` || config.url === '/api/getsecurityrules') {
      config.data = qs.stringify(config.data, { arrayFormat: 'brackets' });
      return config
    }
    let data = JSON.parse(JSON.stringify(config.data))
    // 判断是否个人空间
    if (
      typeof route.query.upaceid !== 'undefined' || 
      (typeof route.query.upace !== 'undefined' && localStorage.getItem('upaceid'))
    ) {
      data.upaceid = route.query.upaceid || localStorage.getItem('upaceid')
    }
    data.hashkey = keyOne
    data.hashcode = jiami(data, keyOne)
    config.data = qs.stringify(data, { arrayFormat: 'brackets' })
    return config
  }
  //拿出data在塞回去
  if (config.data && typeof config.data !== 'string') {
    //暂时先这样，后面考虑换header
    let date = config.url === '/api/deleteapproving' || config.url === "/api/deleteuser" || config.url === '/api/deleterole' || config.url === '/api/deleteorganization' || config.url === '/openapi/deleteoptions' ? config.data : postPlainRequestParams(JSON.parse(JSON.stringify(config.data)))
    // 如果是小程序预览打印页面 就从缓存中取出小程序的token和openid
    if(router.currentRoute.name === 'previewTable') {
      let previewData = sessionStorage.getItem('previewData')
      if(previewData !== '{}') {
        previewData = JSON.parse(previewData)
        date.openid = previewData.openid
        date.accesstoken = previewData.accesstoken
      } else {
        console.log('参数错误')
      }
    } else if (user && user.accesstoken_external) {
      //- 外链模式下使用的accesstoken
      date.accesstoken = user.accesstoken_external//参数加上accesstoken
    } else if (visitorUser && visitorUser.accesstoken && !user) {
      date.accesstoken = visitorUser.accesstoken
    } else if (user && user.accesstoken && config.url !== '/api/getphonemultipleaccounts') {
      //- 正常流程时使用的accesstoken
      // 登录状态清除临时token
      if (temporaryToken) sessionStorage.removeItem('temporaryToken')
      date.accesstoken = user.accesstoken//参数加上accesstoken
    } else if (temporaryToken) {
      date.accesstoken = temporaryToken//参数加上accesstoken
    }
    // 判断是否个人空间
    if (
      typeof route.query.upaceid !== 'undefined' || 
      (typeof route.query.upace !== 'undefined' && localStorage.getItem('upaceid'))
    ) {
      date.upaceid = route.query.upaceid || localStorage.getItem('upaceid')
    }
    date.hashkey = keyOne
    date.hashcode = jiami(date, keyOne)
    config.data = qs.stringify(date, { arrayFormat: 'brackets' })
  } else {
    if (user) {
      let accces = { accesstoken: !user.accesstoken_external ? user.accesstoken : user.accesstoken_external };
      // 判断是否个人空间
      if (
        typeof route.query.upaceid !== 'undefined' || 
        (typeof route.query.upace !== 'undefined' && localStorage.getItem('upaceid'))
      ) {
        accces.upaceid = route.query.upaceid || localStorage.getItem('upaceid')
      }
      accces.hashkey = keyOne;
      accces.hashcode = jiami(accces, keyOne);
      config.data = qs.stringify(accces, { arrayFormat: 'brackets' })
    }
  }
  // 如果是小程序预览打印页面和微信扫码登录 就不走这个
  const unVerify = ['previewTable', 'qrcodelogin']
  if (!user && unVerify.indexOf(router.currentRoute.name) === -1 && !temporaryToken) {
    // 如果是集美移动端的单点登录、企业微信单点登录，则不跳转登录页
    if (!(config.url.indexOf("/api/getssotoken") != -1 || config.url.indexOf("/openapi/wecompcssologin") != -1 || config.url.indexOf("/api/ixiadalogin") != -1 || config.url.indexOf("/api/lmussologin") != -1 || config.url.indexOf("/api/fzgledulogin") != -1 || config.url.indexOf("/openapi/getnewuserbindmsg") != -1)) { 
      // 场景页和外网不要退出登录
      const path = window.location.pathname
      if (path && (path.search('/customInstrument') !== -1 || path.search('/website') !== -1)) {
        return config
      } else {
        router.push({ name: 'login' })
      }
    }
    return config
  }
  return config
}, error => {
  return Promise.reject(error)
})
Axios.interceptors.response.use(response => {
  let date = qs.parse(response.config.data) ? qs.parse(response.config.data) : qs.parse(response.config.params);
  delete date.accesstoken;
  let urls = JSON.parse(JSON.stringify(response.config.url)).slice((response.config.baseURL.length)) + '?' + qs.stringify(date);
  store.commit('delUrl', urls)

  // 如果是文件流就直接返回 response
  if (response.headers['content-type'] === 'application/vnd.ms-excel;charset=UTF-8' || (response.headers['content-type'] && response.headers['content-type'].includes('application/zip'))) {
    return response
  }
  const res = response.data
  if (res.code === 10001) {
    // 如果是集美移动端的单点登录，则不跳转登录页
    let url = apiUrl
    let userAgent = navigator.userAgent;
    let isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
    if (isMobile && url == 'https://guanli.xmjmedu.com' && urls.indexOf("/api/getssotoken") != -1) {
      ElMessage({
        showClose: true,
        message: '网络10001错误，请联系管理员',
        type: 'error',
        duration: 2000
      })
    }
    else {
      localStorage.removeItem("user")
      // 有缓存的时候会调用获取用户信息的接口，单点登录调用该接口可能会报10001
      if(response.config.url === `${response.config.baseURL}/openapi/getnewuserbindmsg`) return false;
      router.push({ name: 'login' })//报错提示  //进入登陆页
      return Promise.reject('未登陆，请去登陆')
    }
  } else if (res.code === 10008) {
    let time = 3;
    let timer;
    timer = setInterval(() => {
      time--;
      document.getElementById('timed').innerHTML = time;//实现动态渲染
      if (time == 0) {
        clearInterval(timer);//如果到0清除倒计时
        document.getElementById('timed').innerHTML = 3;//重新赋为30秒
        ElMessageBox.close(false);//关闭弹窗
        localStorage.removeItem("user")
        router.push({ name: 'login' })//报错提示  //进入登陆页
        return Promise.reject('密码已修改，请重新登录')
      }
    }, 1000);//进行倒计时
    ElMessageBox.alert(
      `<div>您的密码已修改，系统将在<span id='timed' style='color: #06B7AE'>3</span>s后自动退出，重新登录后方可正常使用。</div>`,
      '提示',
      {
        confirmButtonText: '去登录',
        dangerouslyUseHTMLString: true,
        closeOnClickModal: false,
        callback: () => {
          clearInterval(timer);//如果点击清除倒计时
          document.getElementById('timed').innerHTML = 3;//重新赋为30秒
          localStorage.removeItem("user")
          router.push({ name: 'login' })//报错提示  //进入登陆页
          return Promise.reject('密码已修改，请重新登录')
        }
      }
    )
  } else if (res.code === 10003) {
    if (response.config.url.indexOf('/api/getorganizationlist') !== -1) {
      // 老谭说 这个接口单独判断
      return res
    } else {
      alert('系统异常')
    }
    return res
  } else {
    return res
  }
}, error => {
  console.log('请求返回错误拦截', error, JSON.stringify(error));
  // 针对晋江一中部分用户会用手机访问pc地址，然后报以下错误，因此屏蔽移动端端访问以下代码
  let userAgent = navigator.userAgent;
  let isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
  if (isMobile) return false
  // 超时
  if (error.code === 'ECONNABORTED') {
    ElMessageBox.confirm('网络开了点小差，请检查网络稍后登录！', '提示', {
      confirmButtonClass: 'el-button--yeprimary',
      confirmButtonText: '好的',
      showCancelButton: false,
      type: 'warning'
    })
  }
  if (error.code === 'Network Error' || !error.response) {
    ElMessage({
      showClose: true,
      message: '网络错误，请检查网络',
      type: 'error',
      duration: 2000
    })
  }
  //取消请求重复的情况下
  if (error.message) {
    store.commit('delUrl', error.message)
  }
  return Promise.reject(error)
})

export default Axios